import React from "react";
import { NavLink } from "react-router-dom"
import { connect } from 'react-redux';
import {
  loadProjects, saveProjectID,
} from 'actions/MyProjects';

import {
  loadFolders, saveFolderID, deleteFolder
} from 'actions/MyFolders';



function FolderItemCard({ props, data }) {
  const { key, createdById, hasNews, name } = data;


  console.log("########## FOLDER ITEM - name: " + name);

  return (
    <div className="media jr-featured-item">


      <div className="media-body jr-featured-content">
        <div className="jr-featured-content-left">
          <h3 className="mb-1">{name}</h3>

          {/*QUI */}
          <p className="text-grey mb-1"></p>

          <div className="d-flex flex-row">
            <p className="text-grey mb-1">
              {/*QUI */}

            </p>
            <p className="text-grey ml-4 mb-1">
              {/*QUI */}
            </p>
          </div>
        </div>
        <div className="jr-featured-content-right">
          <div>
            {/*QUI */}
            <h2 className="mb-0 jr-font-weight-medium"></h2>
            <p className="text-grey jr-fs-sm"></p>
          </div>
          <p onClick={() => {
             localStorage.setItem('folder_id', key);
            console.log("######### FOLDER ITEM CARD  FOLDER ID: " + localStorage.getItem('folder_id'));
          }} className="text-primary mt-auto mb-0 pointer"><span><NavLink to="/app/files">Seleziona</NavLink></span> <i
              className={`zmdi zmdi-long-arrow-right jr-fs-xxl ml-2 d-inline-block align-middle`} /></p>

          <p onClick={() => {
         
            var userId=localStorage.getItem('user_id');
            props.deleteFolderById({key,userId});

          }} className="text-red mt-auto mb-0 pointer"><span>Elimina</span> <i
              className={`zmdi zmdi-delete jr-fs-xxl ml-2 d-inline-block align-middle`} /></p>
        </div>

      </div>
    </div>
  );
}


export default (FolderItemCard);
